module.exports = __webpack_public_path__ + "static/img/map-pin-customer.dd30456.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doorder/map-pin-customer.png
// module id = pTSD
// module chunks = 0